import { Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { sequenceHelpers } from "../../helpers";
import SequenceDataView from "../AgGrid/SequenceData";

const SequenceData = ({
  sequenceList,
  selectionType,
  spreadName,
}) => {
  const { t } = useTranslation();
  const columns = sequenceHelpers.getColumns(t, selectionType);
  const data = sequenceHelpers.generateData(sequenceList, spreadName);
  const isDataAvailable = data && data.length > 0;

  if (columns.length > 0) {
    const lastColumnIndex = columns.length - 1;
    columns[lastColumnIndex].title = (
      <span>
        {columns[lastColumnIndex].title}
        <Tooltip placement="topLeft" title={t("sequenceTable.tdcInfo")}>
          <sup className="sup">ⓘ</sup>
        </Tooltip>
      </span>
    );
  }

  return (
    <div className="container">
      <div className="table-container">
        <>
          {isDataAvailable && (
            <>
              <SequenceDataView
                reportColumns={columns}
                rows={data}
                selectionType={selectionType}
              />
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default SequenceData;
